import { APIAuth } from "../utils/API"
import { isEmpty } from "../utils/Helper"

export async function checkSN(snList = [], item_id) {
	const postData = new FormData()
	postData.append("sn", JSON.stringify(snList))
	postData.append("item_id", item_id)
	return APIAuth.post(`transaction/sn/check`, postData)
		.then((res) => res.data)
		.catch((err) => err?.response ?? err?.data)
}

export async function getPrmStatus(type = "") {
	const postData = new FormData()
	if (!isEmpty(type)) postData.append("type", type)
	postData.append("is_active", 1)
	return APIAuth.post(`prm/status`, postData)
		.then((res) => res.data)
		.catch((err) => err?.response ?? err?.data)
}
